"use client";

import type { ButtonProps } from "@/app/_ui/components/core/Button";
import { useTranslations } from "next-intl";

import { submitProfessorImpact } from "@/app/_api/hubspot";
import { FormDialogButton } from "../shared/FormDialogButton";
import { ProfessorImpactForm } from "./ProfessorImpactForm";

export interface ProfessorImpactDialogButtonProps {
  onTriggerClick?: () => void;
  buttonVariant?: ButtonProps["variant"];
  buttonSize?: ButtonProps["size"];
  contentClassName?: string;
}

export function ProfessorImpactDialogButton({
  onTriggerClick,
  buttonVariant = "primary",
  buttonSize = "lg",
  contentClassName,
}: ProfessorImpactDialogButtonProps) {
  const t = useTranslations("ClientKeys.professor_impact_form.dialog");

  return (
    <FormDialogButton
      buttonLabel={t("button")}
      title={t("title")}
      description={t("description")}
      successTitle={t("success_title")}
      successMessage={t("success_message")}
      successButton={t("success_button")}
      buttonVariant={buttonVariant}
      buttonSize={buttonSize}
      contentClassName={contentClassName}
      onTriggerClick={onTriggerClick}
      renderForm={({ onSuccess }) => <ProfessorImpactForm onSubmit={submitProfessorImpact} onSuccess={onSuccess} />}
    />
  );
}
